/** Saved questions: save an Ask answer to the wiki, the Ask budget and agent preview, and the wiki index group (EN + VI) */

export const savedQuestionsEn = {
  'ask.budget': 'Context budget',
  'ask.budgetOption': '{tokens}k tokens',
  'ask.budgetHint': 'How much of the wiki the answer may read. A larger budget can answer broader questions; the price per answer stays the same.',
  'ask.preview': 'See what an agent gets',
  'ask.previewHide': 'Hide agent context',
  'ask.previewLoading': 'Packing context…',
  'ask.previewHint': 'The same question as an agent task (free): wiki pages first, then saved questions, Sources, and documents.',
  'ask.previewResult': '{items} items, ~{used} of {budget} tokens',
  'ask.previewFailed': 'Could not load the agent context: {message}',
  'ask.save': 'Save to wiki',
  'ask.saving': 'Saving…',
  'ask.saveHint': 'Adds this answer to the wiki as a saved question. No credits; in team workspaces a reviewer adds it.',
  'ask.saved': 'Saved to the wiki as a saved question.',
  'ask.savedButton': 'Saved',
  'ask.savedPending': 'Saved. It waits in the review queue until someone adds it.',
  'ask.openPage': 'Open page',
  'ask.openReview': 'Open review queue',
  'ask.saveFailed': 'Could not save: {message}',
  'wiki.savedQuestions': 'Saved questions',
  'wiki.savedQuestion': 'Saved question',
}

export const savedQuestionsVi: Record<keyof typeof savedQuestionsEn, string> = {
  'ask.budget': 'Ngân sách token',
  'ask.budgetOption': '{tokens}k token',
  'ask.budgetHint': 'Lượng nội dung wiki mà câu trả lời được đọc. Ngân sách lớn hơn trả lời được câu hỏi rộng hơn; giá mỗi câu trả lời không đổi.',
  'ask.preview': 'Xem agent nhận được gì',
  'ask.previewHide': 'Ẩn ngữ cảnh của agent',
  'ask.previewLoading': 'Đang gom ngữ cảnh…',
  'ask.previewHint': 'Cùng câu hỏi này dưới dạng việc của agent (miễn phí): trang wiki trước, rồi câu hỏi đã lưu, Nguồn và tài liệu.',
  'ask.previewResult': '{items} mục, khoảng {used} trên {budget} token',
  'ask.previewFailed': 'Không tải được ngữ cảnh của agent: {message}',
  'ask.save': 'Lưu vào wiki',
  'ask.saving': 'Đang lưu…',
  'ask.saveHint': 'Thêm câu trả lời này vào wiki thành một câu hỏi đã lưu. Không tốn credit; ở workspace nhóm, người duyệt sẽ thêm vào.',
  'ask.saved': 'Đã lưu vào wiki thành câu hỏi đã lưu.',
  'ask.savedButton': 'Đã lưu',
  'ask.savedPending': 'Đã lưu. Câu trả lời nằm trong hàng chờ duyệt cho đến khi có người thêm vào wiki.',
  'ask.openPage': 'Mở trang',
  'ask.openReview': 'Mở hàng chờ duyệt',
  'ask.saveFailed': 'Không lưu được: {message}',
  'wiki.savedQuestions': 'Câu hỏi đã lưu',
  'wiki.savedQuestion': 'Câu hỏi đã lưu',
}
